// The en-US strings loaded eagerly at boot from the shared barrels (shared
// components + shared-enterprise-tools). index.tsx injects these via
// addTranslations before domain registration, and the nav-label manifest gate
// mirrors them to decide which nav ids already resolve without a domain catalog.
// Single source so the boot path and the gate can't drift.
import { SHARED_COMPONENTS_EN_US } from '@retailer-platform/shared-components/src/exports/shared-components-core'
import { SHARED_ENTERPRISE_TOOLS_EN_US } from '@retailer-platform/domain-shared-enterprise-tools/shared-enterprise-tools-core'

// Cross-domain shared strings: message ids owned by one domain but rendered by a
// file in another domain (or the eager dashboard shell). With domain catalogs
// route-scoped (lazy), such a string is absent whenever its owner's route is not
// active, flashing its raw id. These are kept eager so they always resolve. The
// owner's lazy catalog still overrides on the owner's own route, so this copy only
// serves the off-owner-route case. Keep in sync with the owning catalog if edited;
// the cross-domain reference gate (buildCrossDomainRefs.ts) enforces that every
// remaining cross-domain reference is either eager (here) or in the same domain.
const CROSS_DOMAIN_SHARED_EN_US: Record<string, string> = {
  // dashboard shell -> products (product-edit store-location UI)
  'productsDomain.search.no': 'No',
  'productsDomain.search.yes': 'Yes',
  'productsDomain.view.details.surfaces.marketplace': 'Marketplace',
  'productsDomain.view.details.surfaces.storefrontPro': 'Storefront Pro',
  'productsDomain.view.storeLocations.modal.success': 'Items have been made unavailable',
  'productsDomain.view.storeLocations.override.alert.in.row':
    'The item at this store has been made unavailable via a temporary override. Items will be made available again or be able to be reset by inventory files on',
  'productsDomain.view.storeLocations.override.modal.cancel.button': 'Cancel',
  'productsDomain.view.storeLocations.override.modal.error.text':
    'There was an error while submitting your availability override request',
  'productsDomain.view.storeLocations.override.modal.no.store': 'No store locations to show',
  'productsDomain.view.storeLocations.override.modal.only.selected.filter': 'Only selected?',
  'productsDomain.view.storeLocations.override.modal.partial.failure':
    'Overrides applied to {successCount} of {totalCount} locations. {failedCount} locations did not update. Please retry those locations.',
  'productsDomain.view.storeLocations.override.modal.submit.button': 'Submit',
  'productsDomain.view.storeLocations.override.modal.subtitle': 'Surface: ',
  'productsDomain.view.storeLocations.override.modal.title': 'Temporary Availability Overrides',
  'productsDomain.view.storeLocations.override.modal.warning.text':
    'This take down is temporary and will revert to retailer files after 2 days.',

  // banners -> merchandising (banner form + delete modal)
  'merchandising.hero-banners.details.deleteModal.body':
    'Are you sure you want to permanently delete {name} from your promotional banners?',
  'merchandising.hero-banners.section.content.cta.color.label': 'CTA color',
  'merchandising.hero-banners.section.detail.field.timezone.label': 'Timezone',
  'merchandising.hero-banners.section.location.title': 'Device',

  // banners -> account-management (flyout destination form)
  'accountManagementDomain.validation.required': "{fieldName} can't be blank.",

  // massops -> approvals-management-library (approval-request details)
  'approvalManagementLibrary.searchList.status': 'Status',

  // campaign-management -> landing (multi-retailer pages dashboard title)
  'landingDomain.contentPages.dashboard.pageTitle': 'Landing Page Builder',
}

export const EAGER_EN_US_CATALOG: Record<string, string> = {
  ...SHARED_COMPONENTS_EN_US,
  ...SHARED_ENTERPRISE_TOOLS_EN_US,
  ...CROSS_DOMAIN_SHARED_EN_US,
}
